import { ModelGroup, ModelItemAccessor } from '@mng/model';
import { UvAngebotDataItemAccessor } from '../uvangebot.model.paths';
import { createUvAngebotModel } from './uvangebot.model';

let uvAngebotModel: ModelGroup;
let uvAngebotModelItemAccessor: ModelItemAccessor;

export function getUvAngebotModel(): ModelGroup {
  if (!uvAngebotModel) {
    uvAngebotModel = createUvAngebotModel();
  }
  return uvAngebotModel;
}

export function getUvAngebotModelItemAccessor(): ModelItemAccessor {
  if (!uvAngebotModelItemAccessor) {
    uvAngebotModelItemAccessor = new ModelItemAccessor(getUvAngebotModel());
  }
  return uvAngebotModelItemAccessor;
}

export const uvAngebotItemAccessor: UvAngebotDataItemAccessor = new UvAngebotDataItemAccessor(
  getUvAngebotModelItemAccessor()
);
